import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_protected/workflows/schedule")({
  loader: (ctx) => {
    const organizationId = ctx.context.user.organization?.id;

    if (!organizationId) {
      throw redirect({ to: "/no-organization", throw: true });
    }
  },
});
